

import React, { Component } from 'react';
import { Segment, Popup, Header, Button, Table, Icon, Accordion, Dropdown, Grid } from 'semantic-ui-react';
import accountAPI from '../../../../../../apiCalls/accountAPI'
import ReactToPrint from "react-to-print";
import PrintDaily from './printDaily'
import Confirm from '../confirm'
import { convertEpochToDate, convertNumberStringToDate } from '../../../../../../util/constants';
import { get, isEmpty,isNull, isUndefined} from 'lodash';
import { downloadInvoiceSignedUrl } from "../../../../../../apiCalls/MainFormRequests";
import MonthlyStatementPrint from './MontlyStatementPrint/index';

let lastDate = "";
let lastFilerCode = "";

class MonthlyStatement extends Component {
  constructor() {
    super();
    this.state = {
      values: [],
      activeIndex: -1,
      disabled: {},
      loading: false,
      otherFees: [],
    }
  }

  formatTotal = (duty, tax, add, cvd, other) => {
      let formatDuty = (parseFloat(duty)/100)
      let formatTax = (parseFloat(tax)/100)
      let formatAdd = (parseFloat(add)/100)
      let formatCvd = (parseFloat(cvd)/100)
      let formatOther = parseFloat(other)
      let total = parseFloat(formatDuty + formatTax + formatAdd + formatCvd + formatOther).toFixed(2)
      return(total)
  }

  calculateOtherFees = (array) => {
    let total= 0;
    for (let i = 0; i < array.length; i ++) {
        total = total + parseFloat(array[i].value)

    }
    total= parseFloat(total/100).toFixed(2)
    return total;
  }

  isEmpty = (obj) => {
    for(var key in obj) {
      if(obj.hasOwnProperty(key))
          return false;
    }
    return true;
  }

  componentWillMount = () => {
    const { cbpDailyData, authStatus } = this.props
    const { statementEntries } = cbpDailyData
    if (statementEntries) {
        let totals=[]
        for (let i = 0; i < statementEntries.length; i++) {
            // let total= this.calculateOtherFees(statementEntries[i].fees)
            let total= statementEntries[i].fees && this.calculateOtherFees(statementEntries[i].fees) || 0
            totals.push(total)
        }
        this.setState({ 
          otherFees: totals,
        })
    }

      if (this.isEmpty(authStatus)) {
        this.setState({submitted: false})
      } else if (!this.isEmpty(authStatus) && !authStatus.acceptanceErrorCode) {
            this.setState({ submitted: true })
      } else if (authStatus.acceptanceErrorCode && (authStatus.acceptanceErrorCode === "A"|| authStatus.acceptanceErrorCode === "Q11")) {
            this.setState({ accepted: true })
      } else if (authStatus.acceptanceErrorCode && authStatus.acceptanceErrorCode === "R") {
        this.setState({rejected: true, errorMessage: authStatus.acceptanceErrorMessage})
      }

    }

    componentDidMount = () => {
      let { submitted } = this.state
      if ( submitted ) {
        this.setState({ fetchingStatus: true })
        setTimeout(this.getNewAuthStatus, 5000)
      }
      document.querySelector(".section-container").scrollTop = 0;
    }

  handleClick = () => {
    const { cbpDailyIndex } = this.props
    const { activeIndex } = this.state
    const newIndex = activeIndex === cbpDailyIndex ? -1 : cbpDailyIndex

    this.setState({ activeIndex: newIndex })
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleRemove = (e, { name, value }) => {
    if (value === 'remove') {
      this.setState({ [name]: true })
    }
  }

  handleAuthorize = () => {
    this.setState({ submitLoading: true })
    accountAPI.cbpAuthorization(this.props.cbpDailyData.statementNumber, this.props.cbpDailyData.totalAmountDue, this.props.filerCode)
      .then(response => {
        if (response.data.eventMessage.code === 200) {
          this.setState({ submitted: true, submitLoading: false, confirm: false, rejected: false, fetchingStatus: true})
          setTimeout(this.getNewAuthStatus, 5000)
        } else {
          this.setState({ submitLoading: false, rejected:false, submissionErr: true, confirm: false})
        }
      })
  }

  getNewAuthStatus = () => {
    this.setState({ fetchLoading: true})
    accountAPI.cbpAuthStatus(
      this.props.cbpDailyData.statementNumber,
      this.props.filerCode
    ).then(response => {
      if (response.data.eventMessage.code && response.data.eventMessage.code === 400) {
        this.setState({submitted: false, fetchLoading: false, fetchingStatus: false})
      } else if (response.data.eventMessage.statementNumber && !response.data.eventMessage.acceptanceErrorCode) {
        this.setState({ submitted: true, fetchLoading: false, fetchingStatus: false})
      } else if (response.data.eventMessage.acceptanceErrorCode && (response.data.eventMessage.acceptanceErrorCode === "A"|| response.data.eventMessage.acceptanceErrorCode === "Q11")) {
        this.setState({ accepted: true, fetchLoading: false, fetchingStatus: false})
      } else if (response.data.eventMessage.acceptanceErrorCode && response.data.eventMessage.acceptanceErrorCode === "R") {
        this.setState({rejected: true, fetchLoading: false, errorMessage: response.data.eventMessage.acceptanceErrorMessage, fetchingStatus: false})
      }
    })
  }

  formatPrintDate = (date) => {
    return date.split(" ", 1)
  }

  formatMoney = (num) => {
    let value = num && !isEmpty(num) && num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    if (value === 'NaN') {
      value='0.00'
    }
    return value;
  }

  closeConfirm = () => {
    this.setState({ confirm: false })
  }
  downloadDocument = (bucketName,fileName)=>{
    downloadInvoiceSignedUrl(bucketName, fileName)
    .then((res) => {
      let url = get(res, "data.eventMessage.urls[0]", null);
      window.open(url);
    })
    .catch((err) => console.error(err));
  }
  render() {

    const { activeIndex, submitted, accepted, submitLoading, fetchLoading,  otherFees } = this.state

    const { cbpDailyIndex, country, usersCountry, cbpDailyData, statementPrintDate, importerName, fileName, bucketName} = this.props
    
    const collapseStyle = {
      marginLeft: "20px",
      backgroundColor: "white",
      color: "black",
      fontSize: "8px",
      border: "1px solid #1765AE",
      borderRadius: "2px",
      marginRight: "20px",
      height: "20px",
      width: "104px",
      color: "#1765AE"
    }

    const expandStyle = {
      marginLeft: "20px",
      backgroundColor: "white",
      color: "black",
      fontSize: "8px",
      border: "1px solid #1765AE",
      borderRadius: "2px",
      marginRight: "20px",
      height: "20px",
      width: "104px",
      color: "#1765AE"
    }

    // {activeIndex === 0 ? <Icon name='minus'/> + 'COLLAPSE' : 'EXPAND'}

    const authColors = {
      orange: {
        color: '#F7B500'
      },
      green: {
        color: '#90CE4E'
      },
      red: {
        color: 'red'
      },
      white: {
        color: 'white'
      }
    }

    const options = [
      { 'key': 0, 'text': 'Authorize', 'value': 'authorize' },
      { 'key': 1, 'text': 'Remove from Statement', 'value': 'remove' }
    ]

     let countryName = !isEmpty(usersCountry) || !isUndefined(usersCountry) ? usersCountry : country
// console.log("222222 usersCountry", usersCountry, "country ::", country, "countryName ::", countryName)

    return (
      <center>
        {this.state.confirm  && <Confirm statementNumber={cbpDailyData.statementNumber} handleAuthorize={this.handleAuthorize.bind(this)} close={this.closeConfirm.bind(this)} numberOfShipments={cbpDailyData.statementEntries.length} amountToAuthorize={this.formatMoney((parseFloat(cbpDailyData.totalAmountDue) / 100).toFixed(2))}/>}

        
        <Segment className='cbpPaymentSection'>
          <Accordion>
            <Accordion.Title style={{ cursor: 'default' }} active={activeIndex === cbpDailyIndex} >
              <div className='cbpPaymentSectionHeaderDiv'>
                <Header className='cbpPaymentSectionHeader' as='h3'>
                  <Button onClick={this.handleClick} style={activeIndex === cbpDailyIndex ? collapseStyle : expandStyle}> <Icon name={activeIndex === cbpDailyIndex ? 'minus' : 'add'} /> {activeIndex === cbpDailyIndex ? 'COLLAPSE' : 'EXPAND'} </Button>
                </Header>
                <div className='headerSectionFour'>
                  <Header className='cbpHeaderText top' as='h5'>STATEMENT NUMBER</Header>
                  <Header className='cbpHeaderText' as='h4'>{cbpDailyData.statementNumber}</Header>
                </div>
                <div className='headerSectionFour'>
                  <Header className='cbpHeaderText top' as='h5'>PRINT DATE</Header>
                  <Header className='cbpHeaderText' as='h4'>{convertNumberStringToDate(statementPrintDate, true, false)}</Header>
                </div>
                <div className='headerSectionFour'>
                  <Header className='cbpHeaderText top' as='h5'>TOTAL AMOUNT DUE</Header>
                  <Header className='cbpHeaderText' as='h4'>
                    ${this.formatMoney((parseFloat(cbpDailyData.totalAmountDue)/100).toFixed(2))}
                  </Header>
                </div>

                <div className='headerSectionFour isCanada'>
                  <Header className='cbpHeaderText top' as='h5'>K84 DATE</Header>
                  <Header className='cbpHeaderText' as='h4'>00/00/0000</Header>
                </div>

                <div className='headerSectionFour isCanada'>
                  <Header className='cbpHeaderText top' as='h5'>Entrie</Header>
                  <Header className='cbpHeaderText' as='h4'>11</Header>
                </div>

                <div className='headerSectionFour isCanada'>
                  <Header className='cbpHeaderText top' as='h5'>Broker Liabilities</Header>
                  <Header className='cbpHeaderText' as='h4'>0.00</Header>
                </div>

                <div className='headerSectionFour isCanada'>
                  <Header className='cbpHeaderText top' as='h5'>Paid by Importer</Header>
                  <Header className='cbpHeaderText' as='h4'>42,222.00</Header>
                </div>

                <div class="rightPortion">

                  <div className='headerSectionFour mt4 stmtAmount isCanada'>
                    <Header className='cbpHeaderText' as='h4'>C$ 0,000,000</Header>
                  </div>
                  
                  {!isEmpty(fileName) && !isEmpty(bucketName) ?
                    <div className='headerSectionFour meta_icon enabled' onClick={() => this.downloadDocument(bucketName, fileName)} style={{ cursor: "pointer" }}>
                      <span download="report.xml" className='ui header cbpHeaderText top'>
                        <img src="/images/download.png" style={{ color: "red", display: "block", margin: "10px 8px", width: "20px" }} />
                      </span>
                    </div> :
                    <div className='headerSectionFour meta_icon'>
                      <span download="report.xml" className='ui header cbpHeaderText top'>
                        <img src="/images/download_disabled.png" style={{ color: "red", display: "block", margin: "10px 8px", width: "20px" }} />
                      </span>
                    </div>
                  }
                  <div className='headerPrint meta_icon enabled'>
                    <ReactToPrint
                      trigger={() => <Icon color="specialBlue" style={{ cursor: 'pointer', marginRight: "0 !important"   }} className='paymentPrint' name='print'/>}
                      content={() => this.componentRef}
                    />
                  </div>
                </div>

                <div className='headerSectionFour'>
                  <Header className='cbpHeaderText top' as='h5'></Header>
                  <Header className='cbpHeaderText' as='h4'>
                  </Header>
                </div>
                {/* {activeIndex !== cbpDailyIndex ?
                  <div className='headerSectionAuth'>
                    <Header className='cbpHeaderText' as='h4'>
                      <p className='authIconHeader'>
                        {this.state.rejected ?
                          <Icon style={authColors.red} size='large' name='exclamation circle'/>
                          :
                          <Icon.Group>
                            <Icon style={submitted ? authColors.orange : accepted ? authColors.green : authColors.white} size='large' name='circle outline' />
                            <Icon style={submitted ? authColors.orange : accepted ? authColors.green : authColors.white} size='small' name='check' />
                          </Icon.Group>
                        }
                      </p>
                    </Header>
                  </div>

                  : null} */}

                <div className='headerSectionPayer' style={{top: '20px !important'}}>
                  <Header className='cbpHeaderText top' as='h5'></Header>
                  <Header className='cbpHeaderText' as='h4'></Header>
                </div>
                {/* <div className='cbpDivider'></div> */}
                <div className='headerSectionThree'>
                  <Header className='cbpHeaderText top' as='h5'></Header>
                  <Header className='cbpHeaderText' as='h4'></Header>
                </div>
                {/* <div className='headerPrint'>
                  <ReactToPrint
                      trigger={() => 
                      
                      <Icon style={{ cursor: 'pointer' }} className='paymentPrint' name='print'/>
                    
                    }
                      content={() => this.componentRef}
                  />
                </div> */}
              </div>
            </Accordion.Title>

            {countryName === 'canada'|| countryName === 'CANADA' && <Accordion.Content active={activeIndex === cbpDailyIndex} >
                        <Table basic='very' selectable>
                          <Table.Header>
                          <Table.Row>
                              <Table.HeaderCell>IMPORTER</Table.HeaderCell>
                              <Table.HeaderCell>TRANSACTION#</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>CCN#</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>PURCHASE ORDER</Table.HeaderCell>
                              <Table.HeaderCell>DOC TYPE</Table.HeaderCell>
                              <Table.HeaderCell>PORT</Table.HeaderCell>
                              <Table.HeaderCell>DUTY</Table.HeaderCell>
                              <Table.HeaderCell>SIMA/EXCISE</Table.HeaderCell>
                              <Table.HeaderCell>GST</Table.HeaderCell>
                              <Table.HeaderCell>PENALTY/INTEREST</Table.HeaderCell>

                          </Table.Row>
                          </Table.Header>

                          <Table.Body>
                              { cbpDailyData.statementEntries ? cbpDailyData.statementEntries.map((item, i) => (
                                  <Table.Row style={{cursor: 'pointer'}} onClick={this.props.open} disabled={this.state.i}>
                                  <Table.Cell>{item.dailyStatementNumber}</Table.Cell>
                                  <Popup
                                      size='tiny'
                                      trigger={<Table.Cell>${this.formatMoney((parseFloat(cbpDailyData.statementEntries[i].totalAmountDue)/100).toFixed(2))}</Table.Cell>}
                                      header='OTHER FEES'
                                      on={['hover', 'click']}
                                  >
                                      <center><p className='feePopupHeader'>OTHER FEES</p></center>
                                      <br />
                                      <Grid columns={2}>
                                          {item.fees && item.fees.map((fee, i) => (
                                              <Grid.Row>
                                                  <Grid.Column style={{ width: '70%' }}>
                                                      <p className='cbpOtherFeeLabel'>
                                                      {fee.key}
                                                      </p>
                                                  </Grid.Column>
                                                  <Grid.Column style={{ width: '20%' }}>
                                                      <p className='cbpOtherFeeValue'>${this.formatMoney(parseFloat(fee.value/100).toFixed(2))}</p>
                                                  </Grid.Column>
                                              </Grid.Row>
                                          ))}
                                      </Grid>

                                  </Popup>
                                  <Table.Cell textAlign='right'>{convertEpochToDate(get(item, 'authorizationStatus.dateAccepted', ''), true, false)}</Table.Cell>
                                  <Table.Cell textAlign='right'>{cbpDailyData.processingPort}</Table.Cell>
                              </Table.Row>
                              
                              )) : null }
                              <Table.Row className="lastRow" >
                                <Table.Cell colSpan="2"><button>TOTAL (ON 10/28/2020)</button></Table.Cell>
                                <Table.Cell></Table.Cell>
                                <Table.Cell></Table.Cell>
                                <Table.Cell></Table.Cell>
                                <Table.Cell></Table.Cell>
                                <Table.Cell>C$ 8,000.00</Table.Cell>
                                <Table.Cell>C$ 9,000.00</Table.Cell>
                                <Table.Cell>C$ 9,000.00</Table.Cell>
                                <Table.Cell>C$ 9,000.00</Table.Cell>

                              </Table.Row>
                          </Table.Body>
                        </Table>
              <br /><br /><br />
              <div className="cbpPaymentButtonRow">
                <div className='buttonRowTextDiv'>
                  <p className='buttonRowText buttonRowLabel'>TOTAL</p>
                  <p className='buttonRowText buttonRowTotal'>${this.formatMoney((parseFloat(cbpDailyData.totalAmountDue)/100).toFixed(2))}</p>
                </div>
              </div>
            </Accordion.Content>}

            {countryName === 'US' || countryName === 'UNITED_STATES'  && <Accordion.Content active={activeIndex === cbpDailyIndex} >
                        <Table basic='very' selectable>
                          <Table.Header>
                          <Table.Row>
                              <Table.HeaderCell>DAILY STATEMENT #</Table.HeaderCell>
                              <Table.HeaderCell>TOTAL DUE</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>AUTHORIZED ON</Table.HeaderCell>
                              <Table.HeaderCell textAlign='right'>PORT OF ENTRY</Table.HeaderCell>
                          </Table.Row>
                          </Table.Header>

                          <Table.Body>
                              { cbpDailyData.statementEntries ? cbpDailyData.statementEntries.map((item, i) => (
                                  <Table.Row style={{cursor: 'pointer'}} onClick={this.props.open} disabled={this.state.i}>
                                  <Table.Cell>{item.dailyStatementNumber}</Table.Cell>
                                  <Popup
                                      size='tiny'
                                      trigger={<Table.Cell>{!isNull(cbpDailyData.statementEntries[i]) && !isUndefined(cbpDailyData.statementEntries[i])  ?`$ ${this.formatMoney((parseFloat(cbpDailyData.statementEntries[i].totalAmountDue)/100).toFixed(2))}` : "$0.00"  }</Table.Cell>}
                                      header='OTHER FEES'
                                      on={['hover', 'click']}
                                  >
                                      <center><p className='feePopupHeader'>OTHER FEES</p></center>
                                      <br />
                                      <Grid columns={2}>
                                          {item.fees && item.fees.map((fee, i) => (
                                              <Grid.Row>
                                                  <Grid.Column style={{ width: '70%' }}>
                                                      <p className='cbpOtherFeeLabel'>
                                                      {fee.key}
                                                      </p>
                                                  </Grid.Column>
                                                  <Grid.Column style={{ width: '20%' }}>
                                                      <p className='cbpOtherFeeValue'>${this.formatMoney(parseFloat(fee.value/100).toFixed(2))}</p>
                                                  </Grid.Column>
                                              </Grid.Row>
                                          ))}
                                      </Grid>

                                  </Popup>
                                  <Table.Cell textAlign='right'>{convertEpochToDate(get(item, 'authorizationStatus.dateAccepted', ''), true, false)}</Table.Cell>
                                  <Table.Cell textAlign='right'>{cbpDailyData.processingPort}</Table.Cell>
                              </Table.Row>
                              )) : null }
                          </Table.Body>
                        </Table>
              <br /><br /><br />
              <div className="cbpPaymentButtonRow">
                <div className='buttonRowTextDiv'>
                  <p className='buttonRowText buttonRowLabel'>TOTAL</p>
                  <p className='buttonRowText buttonRowTotal'>${this.formatMoney((parseFloat(cbpDailyData.totalAmountDue)/100).toFixed(2))}</p>
                </div>
              </div>
            </Accordion.Content>}
          </Accordion>
        </Segment>
        <div className='printStatement' style={{ display: 'none'}}>
          <MonthlyStatementPrint ref={el => (this.componentRef = el)} countryName={countryName} key={this.props.key} cbpDailyData={this.props.cbpDailyData} statementPrintDate={statementPrintDate}/>
        </div>
      </center>
    )
  }
}

export default MonthlyStatement;
